"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageMain = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _core = require("@emotion/core");

var ImageMain = function ImageMain(_ref) {
  var others = Object.assign({}, _ref);
  return (0, _core.jsx)(_styles.Root, others, (0, _core.jsx)("picture", null, (0, _core.jsx)("source", {
    media: "(min-width: 1040px)",
    srcSet: "https://assets.creditas.com/website-assets/images/1.0.0/footer/hand-smartphone-new-desktop@2x.webp",
    type: "image/webp"
  }), (0, _core.jsx)("source", {
    media: "(min-width: 1024px)",
    srcSet: "https://assets.creditas.com/website-assets/images/1.0.0/footer/hand-smartphone-new-desktop@2x.png",
    type: "image/png"
  }), (0, _core.jsx)("source", {
    srcSet: "https://assets.creditas.com/website-assets/images/1.0.0/footer/hand-smartphone-new-mobile@2x.webp",
    type: "image/webp"
  }), (0, _core.jsx)("img", {
    src: "https://assets.creditas.com/website-assets/images/1.0.0/footer/hand-smartphone-new-mobile@2x.png",
    alt: "M\xE3o segurando um smartphone, com a tela de simula\xE7\xE3o de Empr\xE9stimo da Creditas",
    loading: "lazy"
  })));
};

exports.ImageMain = ImageMain;
ImageMain.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ImageMain"
};